import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const LABOR_RATES_LABOR_RATE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/labor-rates',
        iconClass: 'fas fa-tools',
        name: '::Menu:LaborRates',
        layout: eLayoutType.application,
        requiredPolicy: 'TTB.Routing',
        order: 7,
        group: 'Franchisee Administration',
      },
    ]);
  };
}
